const DOMAIN =
  process.env.REACT_APP_EMBED_DOMAIN || "https://share.insurgate.test";
const DEFAULT_ENV = process.env.REACT_DEFAULT_EMBED_ENV || "staging";
const DEVELOPMENT = process.env.NODE_ENV === "development";

const DOMAINS = {
  development: "https://share.insurgate.test",
  staging: "https://share.insurgate-staging.com",
  validation: "https://share.insurgate-validation.com",
  production: "https://share.insurgate.be",
};

const PAUL_DOMAINS = {
  development: "https://paul.insurgate.test",
  staging: "https://paul.insurgate-staging.com",
  validation: "https://paul.insurgate-validation.com",
  production: "https://paul.insurgate.be",
};

const getDomain = (env) => {
  return DOMAINS[env] || DOMAINS.staging;
};

const getPaulDomain = (env) => {
  return PAUL_DOMAINS[env] || PAUL_DOMAINS.staging;
};

export { DOMAIN, DEFAULT_ENV, DEVELOPMENT, DOMAINS, getDomain, getPaulDomain };
